import { Color } from "../../../maths/Color";
import { Matrix4x4 } from "../../../maths/Matrix4x4";
import { Vector2 } from "../../../maths/Vector2";
import { Vector3 } from "../../../maths/Vector3";
import { Vector4 } from "../../../maths/Vector4";
import { SetRenderDataCMD, RenderCMDType, SetShaderDefineCMD } from "../../DriverDesign/RenderDevice/IRenderCMD";
import { ShaderDataType } from "../../DriverDesign/RenderDevice/ShaderData";
export class WebGLSetRenderData extends SetRenderDataCMD {
    get dataType() {
        return this._dataType;
    }
    set dataType(value) {
        this._dataType = value;
    }
    get propertyID() {
        return this._propertyID;
    }
    set propertyID(value) {
        this._propertyID = value;
    }
    get dest() {
        return this._dest;
    }
    set dest(value) {
        this._dest = value;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        switch (this.dataType) {
            case ShaderDataType.Int:
            case ShaderDataType.Float:
            case ShaderDataType.Bool:
                this.data_number = value;
                this._value = this.data_number;
                break;
            case ShaderDataType.Matrix4x4:
                !this.data_mat && (this.data_mat = new Matrix4x4());
                value.cloneTo(this.data_mat);
                this._value = this.data_mat;
                break;
            case ShaderDataType.Color:
                !this.data_Color && (this.data_Color = new Color());
                value.cloneTo(this.data_Color);
                this._value = this.data_Color;
                break;
            case ShaderDataType.Texture2D:
                this._value = this.data_texture = value;
                break;
            case ShaderDataType.Vector4:
                !this.data_v4 && (this.data_v4 = new Vector4());
                value.cloneTo(this.data_v4);
                this._value = this.data_v4;
                break;
            case ShaderDataType.Vector2:
                !this.data_v2 && (this.data_v2 = new Vector2());
                value.cloneTo(this.data_v2);
                this._value = this.data_v2;
                break;
            case ShaderDataType.Vector3:
                !this.data_v3 && (this.data_v3 = new Vector3());
                value.cloneTo(this.data_v3);
                this._value = this.data_v3;
                break;
            case ShaderDataType.Buffer:
                this._value = this.data_Buffer = value;
                break;
            default:
                break;
        }
    }
    constructor() {
        super();
        this.type = RenderCMDType.ChangeData;
    }
    apply(context) {
        switch (this.dataType) {
            case ShaderDataType.Int:
                this.dest.setInt(this.propertyID, this.value);
                break;
            case ShaderDataType.Float:
                this.dest.setNumber(this.propertyID, this.value);
                break;
            case ShaderDataType.Bool:
                this.dest.setBool(this.propertyID, this.value);
                break;
            case ShaderDataType.Matrix4x4:
                this.dest.setMatrix4x4(this.propertyID, this.value);
                break;
            case ShaderDataType.Color:
                this.dest.setColor(this.propertyID, this.value);
                break;
            case ShaderDataType.Texture2D:
                this.dest.setTexture(this.propertyID, this.value);
                break;
            case ShaderDataType.Vector4:
                this.dest.setVector(this.propertyID, this.value);
                break;
            case ShaderDataType.Vector2:
                this.dest.setVector2(this.propertyID, this.value);
                break;
            case ShaderDataType.Vector3:
                this.dest.setVector3(this.propertyID, this.value);
                break;
            case ShaderDataType.Buffer:
                this.dest.setBuffer(this.propertyID, this.value);
                break;
            default:
                break;
        }
    }
}
export class WebGLSetShaderDefine extends SetShaderDefineCMD {
    get define() {
        return this._define;
    }
    set define(value) {
        this._define = value;
    }
    get dest() {
        return this._dest;
    }
    set dest(value) {
        this._dest = value;
    }
    get add() {
        return this._add;
    }
    set add(value) {
        this._add = value;
    }
    constructor() {
        super();
        this.type = RenderCMDType.ChangeShaderDefine;
    }
    apply(context) {
        if (this.add) {
            this._dest.addDefine(this.define);
        }
        else {
            this._dest.removeDefine(this.define);
        }
    }
}
